import React from 'react';
import '../styles/AboutPage.css'; // Import CSS for styling

const AboutPage = () => {
  return (
    <div className="about-page">
      {/* Dynamic Header */}
      <header className="dynamic-header">
        <h1>About Us</h1>
        <p>
          Welcome to Cybersecurity & Digital Twin Solution by AIOTICS Technology to deliver cutting-edge IoT and automation solutions.
        </p>
      </header>

      {/* Grid Container */}
      <div className="grid-container">
        {/* Meraki App Section */}
        <section className="meraki-section animated-fly-in-left">
          <h2>Cybersecurity Simulation IoT Lab</h2>
          <p>
  The Cybersecurity OT Simulation Lab is a specialized platform designed to replicate and secure Operational Technology (OT) environments in critical sectors such as Pharma, Manufacturing, and Power Plants. It empowers cybersecurity teams to detect vulnerabilities, test responses, and train staff in a controlled, realistic setting. Key features include:
</p>
<ul>
  <li><strong>Real-Time Monitoring:</strong> Simulate and monitor industrial systems, ICS/SCADA traffic, and device behavior in real time to detect anomalies and potential threats.</li>
  <li><strong>Automated Attack Scenarios:</strong> Run controlled simulations of cyberattacks like ransomware, supply chain breaches, or insider threats to test and improve defenses.</li>
  <li><strong>OT Device Integration:</strong> Emulate PLCs, RTUs, and HMIs to create a comprehensive training and testing ground for industrial systems.</li>
  <li><strong>Scalability:</strong> Scale lab environments from single-site simulations to multi-site critical infrastructure networks, mirroring real-world complexity.</li>
  <li><strong>Security & Compliance:</strong> Enforce industry-specific cybersecurity frameworks (e.g., NIST, ISA/IEC 62443) to assess readiness and ensure compliance.</li>
</ul>
<p>
  With this simulation lab, organizations in Pharma, Manufacturing, and Power can proactively enhance their OT cybersecurity posture, reduce operational risk, and build resilience against evolving threats.
</p>

        </section>

        {/* AIOTICS Technology Section */}
        <section className="aiotics-section animated-fly-in-right">
          <h2>AIOTICS Technology Private Limited</h2>
          <p>
            AIOTICS Technology Private Limited is a innovative provider of IoT and automation solutions. Our mission is to empower businesses with smart technologies that drive efficiency, sustainability, and growth. Key services include:
          </p>
          <ul>
            <li><strong>IoT Solutions:</strong> Design and implement end-to-end IoT systems for industries like manufacturing, healthcare, and agriculture.</li>
            <li><strong>Automation Services:</strong> Develop custom automation solutions to optimize processes and reduce operational costs.</li>
            <li><strong>Data Analytics:</strong> Leverage AI and machine learning to analyze IoT data and generate actionable insights.</li>
            <li><strong>Cloud Integration:</strong> Enable scalable cloud-based platforms for IoT device management and data storage.</li>
            <li><strong>Consulting:</strong> Provide expert guidance on digital transformation strategies and IoT adoption.</li>
          </ul>
          <p>
            AIOTICS Technology is committed to delivering innovative solutions that transform businesses and enhance customer experiences.
          </p>
        </section>
      </div>

      {/* Visit Our Website Section */}
      <footer className="website-footer">
        <a href="https://aiotics.in" target="_blank" rel="noopener noreferrer" className="neon-link">
          Visit Our Website
        </a>
      </footer>
    </div>
  );
};

export default AboutPage;